<template>
  <div class="d-flex flex-column">
    <div
      v-for="(notification, index) in notifications.slice(0, maxVisibleCount)"
      :key="index"
      class="d-flex justify-content-between align-items-center py-2"
      :class="{
        'border-bottom': index !== notifications.length - 1,
      }"
    >
      <div>
        <span class="text-muted">
          {{ basicFormatter(notification.createdAt) }}
        </span>
        <span class="text-muted ms-1">
          {{ notificationTypeLabel(notification.actionType) }}
        </span>
      </div>
      <div>
        <BasicButton
          outlined
          icon="pi pi-eye"
          @click="$emit('gotoNotification', notification.id)"
        >
          詳細
        </BasicButton>
        <BasicButton
          class="ms-2"
          icon="pi pi-check"
          @click="
            () => {
              notification.read = true;
              $emit('markAsRead', notification.id);
            }
          "
        >
          既読
        </BasicButton>
      </div>
    </div>
    <div v-if="showMoreReadButton" class="d-flex justify-content-center mt-3">
      <!-- もっと見る (モーダルを開き一覧を表示) -->
      <BasicButton outlined icon="pi pi-eye" @click="openModal">
        もっと見る
      </BasicButton>
    </div>

    <Dialog
      v-model:visible="visible"
      modal
      header="通知一覧"
      dismissable-mask
      block-scroll
      style="width: 90%; max-width: 500px"
    >
      <div class="d-flex flex-column">
        <div
          v-for="(notification, index) in notifications"
          :key="index"
          class="d-flex justify-content-between align-items-center py-2"
          :class="{
            'border-bottom': index !== notifications.length - 1,
          }"
        >
          <div>
            <span class="text-muted">
              {{ basicFormatter(notification.createdAt) }}
            </span>
            <span class="text-muted ms-1">
              {{ notificationTypeLabel(notification.actionType) }}
            </span>
          </div>
          <div>
            <BasicButton
              outlined
              icon="pi pi-eye"
              @click="$emit('gotoNotification', notification.id)"
            >
              詳細
            </BasicButton>
            <BasicButton
              class="ms-2"
              icon="pi pi-check"
              @click="
                () => {
                  notification.read = true;
                  $emit('markAsRead', notification.id);
                }
              "
            >
              既読
            </BasicButton>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { useRouterUtil } from "/@/vue/composables";
import { basicFormatter } from "/@/modules/luxon";
import { Notification, notificationTypeLabel } from "/@/types";
import { BasicButton } from "/@/vue/components/Atom";
import { computed, ref } from "vue";
import Dialog from "primevue/dialog";

const { goto } = useRouterUtil();

const props = defineProps<{
  notifications: Notification[];
  maxVisibleCount: number;
}>();

defineEmits<{
  (e: "markAsRead", id: number): void;
  (e: "gotoNotification", id: number): void;
}>();

const showMoreReadButton = computed(() => {
  return props.notifications.length > props.maxVisibleCount;
});

const visible = ref(false);

function openModal() {
  visible.value = true;
}
</script>

<style lang="scss" scoped></style>
